export const version = '1.6.0';
